/* eslint-disable max-len */ import { getContent, getPatchNote, PatchNoteType } from '@colonist/types';
import RushDevPnBanner from '@static/images/rush_dev_pn_banner.png';
// import AnnouncementColonistTournament from '@static/images/announcement_colonist_tournament.png'
// import AnnouncementGift from '@static/images/announcement_gift.png'
// import DangFixPixelatedFullscreenPopupImageBefore from '@static/images/patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-before.png'
// import DangFixPixelatedFullscreenPopupImageAfter from '@static/images/patch_notes_images/dang-fix-pixelated-fullscreen-popup-image-after.png'
// import DangUpdatePaymentSuccessfulPopupBefore from '@static/images/patch_notes_images/dang-update-payment-successful-popup-before.png'
// import DangUpdatePaymentSuccessfulPopupAfter from '@static/images/patch_notes_images/dang-update-payment-successful-popup-after.png'
// import StanFixSafariLowResolutionDiceBefore from '@static/images/patch_notes_images/stan-fix-safari-low-resolution-dice-before.jpg'
// import StanFixSafariLowResolutionDiceAfter from '@static/images/patch_notes_images/stan-fix-safari-low-resolution-dice-after.jpg'
// import MuhammadRenameLobbyToRoomsBefore from '@static/images/patch_notes_images/rename-lobby-to-rooms-before.png'
// import MuhammadRenameLobbyToRoomsAfter from '@static/images/patch_notes_images/rename-lobby-to-rooms-after.png'
// import MuhammadFixUsernameAvatarNotShowingInChatBefore from '@static/images/patch_notes_images/message-appears-without-username-avatar-before.png'
// import MuhammadFixUsernameAvatarNotShowingInChatAfter from '@static/images/patch_notes_images/message-appears-without-username-avatar-after.png'
export class PatchNoteData {
    getContributionCount(username) {
        let count = 0;
        for (const pn of this.getAll()){
            for (const content of pn.contents){
                for (const contributor of content.contributors){
                    if (contributor == username) count += 1;
                }
            }
        }
        return count;
    }
    getAnnouncements() {
        return this.announcement;
    }
    getAll() {
        return this.patchNotes;
    }
    getLast5() {
        return this.patchNotes.slice(0, 5);
    }
    getLatest() {
        return this.patchNotes.slice(0, 1);
    }
    constructor(){
        this.patchNotes = [];
        this.announcement = [];
        this.announcement.push(`<a href="https://blog.colonist.io/colonist-rush-development/" target="_blank"><img src="${RushDevPnBanner}" style="width: 100%"></a>`);
        this.announcement.push('<b>Join this weekend\'s Colonist Championship 2026 qualifier. <a href="https://tinyurl.com/colonist4ptourney70" target="_blank">Register here.</a></b>');
        // this.announcement.push(`<a href="/championship" target="_blank"><img src="${AnnouncementColonistTournament}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="https://www.youtube.com/@colonistio/?sub_confirmation=1" target="_blank"><img src="${AnnouncementColonistCon24}" style="width: 100%"></a>`)
        // this.announcement.push('Check out our latest video! </b><a href="https://youtu.be/R_hl_CAefrg" target="_blank">1 v 1 Guide!</a>!</b>')
        // this.announcement.push('<iframe style="display: block; margin: 0 auto;" width="560" height="315" src="https://www.youtube.com/embed/xtkDDYhfMHw?si=CugURvk5342Fyj02" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>')
        // this.announcement.push('<b>We are looking for a Community Manager. Check out <a href="/careers" target="_blank">careers</a>!</b>')
        // this.announcement.push(`<a href="https://blog.colonist.io/colonist-io-2023-summary/"><img src="${Announcement2023YearlyStats}" style="width: 100%"></a>`)
        // this.announcement.push(`<a href="/store#gift"><img src="/${AnnouncementGift}" style="width: 100%"></a>`)
        // Jeff
        // Refactor MechanicKnight for deprecated fields
        // Refactor MechanicProgressCardPoliticsSaboteur to remove deprecated fields
        // Refactor MechanicProgressCardPoliticsIntrigue to remove deprecated fields
        // Refactor MechanicKnightActions to remove deprecated fields
        // Refactor MechanicProgressCardTradeCommercialHarbor to remove deprecated fields
        // Refactor MechanicProgressCardScienceCrane to remove deprecated fields
        // Refactor MechanicProgressCardScienceAlchemist
        // Andre
        // Rob
        // Oguz
        // [Mobile] Fixed the end-game Subscribe button opening the homepage instead of the store
        // Irfan
        // Muhammad
        // Sinan
        // Marc
        // Dang
        // Efe
        // Mo
        // Ben
        // William
        // Ergen
        // ! PUBLIC PN FORMAT: v298.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], '/v298/before-image.png', '/v298/after-image.png', 'FeatureUpvote link'))
        const v315 = [];
        v315.push(getContent(PatchNoteType.Update, 'Clarified insufficient resource messages in game log', undefined, '/v314/insufficient-resources-log-before.png', '/v314/insufficient-resources-log-after.png'));
        v315.push(getContent(PatchNoteType.Fix, 'Fix floating text overflowing', undefined, '/v315/floating-text-overflow-before.png', '/v315/floating-text-overflow-after.png'));
        // Marc
        // Clicking on Invite Friends from reward section in store now opens the invite friends dialog on Discord Mobile portrait
        // Ergen
        // Mobile & discord store view event
        // Store tab and toggle events
        this.patchNotes.push(getPatchNote(2026, 7, 28, 315, v315));
        const v314 = [];
        v314.push(getContent(PatchNoteType.Update, 'The end-game screen now shows "Opponent resigned" to the winner when a 1v1 opponent resigns'));
        v314.push(getContent(PatchNoteType.Update, 'Redesigned the vote popup with bigger, easier-to-tap buttons and a clearer layout', undefined, '/v314/vote-popup-before.png', '/v314/vote-popup-after.png'));
        v314.push(getContent(PatchNoteType.Update, 'Long player names no longer push the action out of view in the game status bar'));
        v314.push(getContent(PatchNoteType.Fix, 'Fixed the Bots tab not remembering your map selection'));
        v314.push(getContent(PatchNoteType.Update, 'Added victory points when choosing a player to rob, so you can see who is leading', undefined, '/v314/robber-vp-before.png', '/v314/robber-vp-after.png'));
        // Jeff
        // 3 Refactor MechanicProgressCardPoliticsDiplomat
        // 4 Refactor MechanicKnightActivation
        // 5 Refactor MechanicKnightUpgrade
        // 6 Refactor MechanicKnightRemoval
        // Oguz
        // [Colonist Rush] Matchmaking tips on the mobile searching screen, softly promoting Colonist Rush
        // [Colonist Rush] Fixed the next-turn vote button appearing faded after you voted
        // Fixed swiping through bot maps on the mobile app moving the whole page instead of scrolling the map list
        // Added a Subscribe button to locked map and game mode info popups
        // [Colonist Rush] Added bot difficulty selection to the Rush bots card
        // Irfan
        // [Colonist Rush] Added impression tracking to the homepage and in-game side-rail Rush ads
        // Added impression and click tracking to the end-game ad box (gifs and store promos)
        // Muhammad
        // React Refactor - replace adblock popup
        // React Refactor - move rewards program dialog
        // React Refactor - build pagetabs
        // React Refactor - build modeselector cards: beginner, rushbots, casual 1v1/4p
        // React Refactor - integrate refer friends dialog
        // break up playpage cypress tests
        // React Refactor - move endgame membership incentive dialog
        // make bot map selector a premium-only option
        //
        // Marc
        // Fix internal and external links from More page opening on Discord Mobile portrait
        // Fix share room button not working on Discord Mobile portrait
        // Creating a room on Discord Mobile portrait now opens the invite friends dialog
        // Fix FAQ link opening on Discord Mobile portrait
        // Fix Discord Activity loading screen logo being cropped/too big in portrait
        // Dang
        // [Mobile] Store - Double Tap Payment
        // Create Stripe payment client secret API
        this.patchNotes.push(getPatchNote(2026, 7, 21, 314, v314));
        const v313 = [];
        v313.push(getContent(PatchNoteType.Update, 'Added map selection to the Bots tab'));
        v313.push(getContent(PatchNoteType.Fix, 'Fixed being unable to resign while the game is paused'));
        // Jeff
        // Refactor MechanicDiscardProgressCards to remove deprecated fields. Touched SBP
        // 14 Refactor all of beginner mode to remove deprecated fields
        // 1 Refactor MechanicProgressCardPoliticsDeserter to remove deprecated fields
        // 2 Refactor MechanicProgressCardPoliticsBishop
        // Oguz
        // Brought back the regular lobby and in-game ads alongside the Colonist Rush ads
        // [Colonist Rush] Fixed required resources not updating while a build button is open
        // [Colonist Rush] End-game popup nudging players to try Colonist Rush
        // Muhammad
        // React Refactor - Build ModeSelectorCardBase
        // ck - updates the 1 progress card you should discard with the newly selected one on click
        // revert depleted icon states
        // React Refactor - improve typing for ModeSelector
        // React Refactor - move remaining dialogs to react
        // move scrollbar of tabs primitive to far right always
        // React Refactor - move delete account dialog
        // show ads for shuffle bot games
        // Sinan
        // Fix localhost becoming unresponsive after a few file changes
        // Marc
        // Remove landing page on Discord Mobile portrait
        // Disable store purchase on Discord Mobile portrait
        // Fix external links opening on Discord Mobile portrait
        // Hide Logout and Device Info buttons on Discord Mobile portrait
        // Dang
        // [Mobile] Fixed the map moves when keyboard opens
        // Fix useContainerQuery hook infinite loop
        // Handle Sandbox/Prod Android IAP purchases
        // React Refactor - Build LoginProviderAccounts component
        // Add width x height text to ResizableWrapper
        // [Mobile App] Fix Server select background color
        // [Mobile App] Display the correct localized price for In-App Purchase
        // [Mobile App] Mobile use device language by default until user select the language preference
        // Efe
        // Fixed in-game action buttons flickering when hovering near their edge
        // Mo
        // Improve Friends table column visibility on narrow profile widths
        // Accept, decline, and cancel friend requests by user id in the profile friends tab
        // React Refactor - Build SettingsTab component
        // Fixed being able to pick a resource the bank has run out of on a gold tile or aqueduct
        // Ergen
        // Mobile In-room Become a Member CTA event
        // Implemented in-game info window analytic events
        // Ali
        // Stefan
        // Ben
        // William
        // ! PUBLIC PN FORMAT: v298.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], '/v298/before-image.png', '/v298/after-image.png', 'FeatureUpvote link'))
        this.patchNotes.push(getPatchNote(2026, 7, 14, 313, v313));
        const v312 = [];
        v312.push(getContent(PatchNoteType.Fix, 'Fixed the trade ratio text (2:1, 3:1) on ports rendering with the wrong font', undefined, '/v312/port-trade-text-before.png', '/v312/port-trade-text-after.png'));
        v312.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed the trade panel being cut off by the chat, log, and rules buttons', undefined, '/v312/trade-offers-before.png', '/v312/trade-offers-after.png'));
        // Oguz
        // [Colonist Rush] Pitch Ranked Rush to ranked players after their games
        // [Colonist Rush] Pre-select Rush in the ranked lobby for players who never tried it
        // Irfan
        // [Colonist Rush] Play Rush ads now open the how-to-play popup instead of the rules page
        // [Colonist Rush] Added impression and click analytics to Rush ads
        // Muhammad
        // [mobile - ios] fix external link opening
        // allow horizontal scroll in scrollfadecontainer
        // remove blackbars from discord mobile android portrait mode
        // React Refactor - Build Tabs primitive
        // add optional max width to tabs primitive
        // Dang
        // Fix useContainerQuery hook infinite loop
        // Handle Sandbox/Prod Android IAP purchases
        // React Refactor - Build LoginProviderAccounts component
        // Add width x height text to ResizableWrapper
        // [Mobile App] Fix Server select background color
        // Mo
        // Fix resource chat commands to draw from bank
        this.patchNotes.push(getPatchNote(2026, 7, 7, 312, v312));
        const v311 = [];
        v311.push(getContent(PatchNoteType.Blog, 'How we built Colonist Rush! <a href="https://blog.colonist.io/colonist-rush-development/" target="_blank">Read here!</a>', undefined, undefined, undefined, 'https://blog.colonist.io/colonist-rush-development/'));
        v311.push(getContent(PatchNoteType.Update, '[Colonist Rush] Vote to pass turn is now irreversible'));
        v311.push(getContent(PatchNoteType.Update, '[Discord] Single-player games now stay open longer if you disconnect'));
        v311.push(getContent(PatchNoteType.Fix, '[Colonist Rush] Fixed the extra time added after steal events'));
        v311.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed board not panning when dragging from a game piece'));
        // Jeff
        // 9 Refactor BotTradingBase to remove deprecated fields
        // 10 Refactor BotsSpecialBuildPhase to remove deprecated fields
        // 11 Refactor MechanicMerchantHelper & MechanicProgressCardTradeMerchant to remove deprecated fields
        // 12 Refactor MechanicAcquireProgressCardsAfterDiceRoll to remove deprecated fields
        // 13 Refactor MechanicProgressCardTradeMonopoly to remove deprecated fields
        // Muhammad
        // fix history table in mobile profile popup not scrolling
        // React Refactor - add Image primitive
        // update leaderboardpage breakpoints & code cleanup
        // Design System - Dialogs - 1
        // Design System - Dialogs - 2
        // Design System - Dialogs - 3: Replace dialogs with new layout
        // React Refactor - replace all images with Image primitive
        // fix squished pagetabs & general layout issues
        // Update leaderboard layout to fix illegible cta buttons
        // Sinan
        // [Mobile] Fixed mobile membership icon overflow on leaderboard
        // [Mobile] Fixed the "Log in to play Ranked" button being cut off on the leaderboard
        // Marc
        // Remove Google Analytics events sending
        // Update broken link in docs
        // Dang
        // [Mobile App] Upgrade Expo to 54
        // Mo
        // React Refactor - build and integrate profile page friends tab
        // Refactor table filler row into shared Table
        // Ben
        // Fix PageTabs overflow
        // Consolidate abandon game timer calculation
        // Ergen
        // early return in goToTab function for Game scene
        this.patchNotes.push(getPatchNote(2026, 6, 30, 311, v311));
        const v310 = [];
        v310.push(getContent(PatchNoteType.Update, '[Mobile] Larger chat and log buttons', undefined, '/v310/mobile-chat-log-buttons-before.png', '/v310/mobile-chat-log-buttons-after.png'));
        v310.push(getContent(PatchNoteType.Update, 'Updated the designs of vote request modals', undefined, '/v310/vote-modal-design-before.png', '/v310/vote-modal-design-after.png'));
        v310.push(getContent(PatchNoteType.Update, 'Clicking anywhere on the trade offers bar now toggles trade visibility'));
        // Jeff
        // 8 Refactor MechanicTutorialMode to remove deprecated fields
        // Oguz
        // [Colonist Rush] Added a "Play Colonist Rush" button to the leaderboard bottom CTAs
        // Made Colonist Rush the default mode in rooms
        // Muhammad
        // React Refactor - move dice roll dialog
        // React Refactor - update button to match design system
        // React Refactor - update popup sizes
        // Improve UIGameActionBox responsiveness
        // Dang
        // React Refactor - Build RankedPlayerInfoCard component
        // React Refactor - Moving variables, functions that violate boundaries rule in UI-Game
        // [Mobile] Fix chat container cut off when keyboard opens
        // React Refactor - Build PlayerInformation component
        // Efe
        // Made landing page footer styling consistent (bold language, removed dividers, increased spacing, language hover)
        // Ben
        // Build refer friends dialog component in storybook
        // Build friends table component in storybook
        // Ergen
        // Fixed "leave the room?" popup bug
        // Andy
        // Fix irrigation log while only 1 resource left.
        // Show stolen card for spectator in 1v1
        // Make the color change popup icons to different settlements' colors instead of lighting
        // Rush Mode: Fix behavior of stealing a card from a player who already has no cards left
        // Reorder the in-game player dropdown order
        // Add Discard All Command for test and develop
        // Prevent repetitive reports from the same user within 7 days from triggering multiple warning notifications.
        this.patchNotes.push(getPatchNote(2026, 6, 23, 310, v310));
        const v309 = [];
        v309.push(getContent(PatchNoteType.Update, 'All our pages are now translated'));
        v309.push(getContent(PatchNoteType.Update, 'New Game Settings design', undefined, '/v309/game-settings-design-before.png', '/v309/game-settings-design-after.png'));
        // Jeff
        // 1 Refactor MechanicAqueduct to remove deprecated fields
        // 2 Refactor MechanicCityImprovement to remove deprecated fields
        // 3 Refactor MechanicPirate to remove deprecated fields
        // 4 Refactor MechanicShipMove to remove deprecated fields
        // 5 Refactor CK Barbarian logic to remove deprecated fields
        // 6 Refactor MechanicShip to remove deprecated fields
        // 7 Finish game event history hydration (validation)
        // Muhammad
        // React Refactor - duplicate Button component into ui-game
        // React Refactor - move join room dialog
        // React Refactor - build change language dialog
        // React Refactor - move mobile profilepage player search
        // React Refactor - move report player dialog
        // React Refactor - move change language dialog
        // React Refactor - move request push notification dialog
        // React Refactor - build free play dice roll dialog
        // Sinan
        // Fix resource cards tooltip always showing discard limit
        // React Refactor - convert Leaderboards page to React
        // Fixed special characters like "&" showing as raw code in country names and menu tabs
        // v309.push(getContent(PatchNoteType.Update, '[Cities & Knights] Knight upgrade button now shows a disabled "0" badge instead of disappearing when you have no higher-level knights left to upgrade into', undefined, '/v309/knight-upgrade-zero-badge-before.png', '/v309/knight-upgrade-zero-badge-after.png'))
        // Marc
        // v309.push(getContent(PatchNoteType.Fix, '[Tablet] Map no longer resizes when opening the keyboard.'))
        // Dang
        // Build UIGameSettingsDialog component in storybook
        // Handle Xsolla webhook bigint ids
        // Remove Google Optimize
        // React Refactor - Decouple all platform variables and remove UIContext from ui-game
        // React Refactor - Decouple user states and remove UserStateContext from ui-game
        // Mo
        // Fixed horizontal scrolling when viewing another player's profile History tab
        // Expand history table opponents column to multiple lines on for selected rows
        // Fixed playing a Knight late in your turn leaving too little time to use the card you steal after moving the robber
        // Stefan
        // Added depleted states and floating text feedback when running out of pieces
        // Fix wrong order of Commodities in bank trade ratio tooltip
        // Update SBP tooltip text when request is placed
        // Fixed add friend icon and button for existing friends
        // Adjust mobile how-to-play rush container
        // Efe
        // Added spacing between the announcement text and banner in patch notes
        // Simplified and shortened tooltip text across game and platform
        // Ergen
        // Fixed rolled dice stone visibility
        // Fixed robber icon visibility
        this.patchNotes.push(getPatchNote(2026, 6, 16, 309, v309));
        const v308 = [];
        v308.push(getContent(PatchNoteType.Fix, '[Mobile] Prevent autoscroll while reading the game logs'));
        v308.push(getContent(PatchNoteType.Fix, '[Web] Fixed build placement circles always showing on the map', undefined, '/v308/build-placement-circles-before.png', '/v308/build-placement-circles-after.png'));
        // Muhammad
        // show how many coins are needed to change username in popup
        // React Refactor - move bunch of simple popups over
        // React Refactor - move bunch of translucent overlays over
        // React Refactor - build edit profile dialog container
        // React Refactor - build report player dialog
        // React Refactor - build request notification dialog
        // React Refactor - move edit profile dialog
        // leaving room from edit profile dialog now confirms to leave the room
        // Sinan
        // Fixed membership icons being cut off on the leaderboard at ranks #10 and below
        // [Leaderboards] Fixed Win % and Games columns disappearing earlier than necessary on smaller screens
        // Dang
        // Handle Xsolla webhook bigint ids
        // Remove Google Optimize
        // React Refactor - Decouple all platform variables and remove UIContext from ui-game
        // Make footer rules button a link
        // Mo
        // Make HistoryTable more compact and prevent truncation of dates on smaller screens
        // [Rush] Fixed robber token advancing after robber placement instead of after the steal resolves
        // [Rush] Fixed the robber being placed automatically when the discard timer expired instead of giving the robber mover a timed placement prompt
        // Fixed layout issues on the Championship 2026 page
        // Goku
        // Increased Ranked Rush initial road placement timer from 5 to 6
        // Antonio
        // React Refactor - Build ModeLoginToPlay React Component
        // React Refactor - Build ModeSelectorBadge React
        // William
        // Fixed text for Ranked modes on matchmaking screen
        this.patchNotes.push(getPatchNote(2026, 6, 9, 308, v308));
        const v307 = [];
        v307.push(getContent(PatchNoteType.Blog, 'Announcing Colonist Rush! <a href="https://blog.colonist.io/announcing-colonist-rush/" target="_blank">Read here!</a>', undefined, undefined, undefined, 'https://blog.colonist.io/announcing-colonist-rush/'));
        v307.push(getContent(PatchNoteType.Feature, 'Colonist Rush Ranked is Back!'));
        v307.push(getContent(PatchNoteType.Feature, 'Play Colonist Rush vs Bots!'));
        v307.push(getContent(PatchNoteType.Feature, 'Colonist Rush is free in rooms for a limited time!'));
        v307.push(getContent(PatchNoteType.Update, '[Colonist Rush] Initial placements are FASTER!'));
        v307.push(getContent(PatchNoteType.Update, '[Colonist Rush] Ranked season shows on your profile', undefined, undefined, '/v307/rush-stats-after.png'));
        v307.push(getContent(PatchNoteType.Update, '[Mobile] Tooltips now open with a single tap and close on tapping again or elsewhere'));
        v307.push(getContent(PatchNoteType.Fix, '[Colonist Rush] Fixed trade requests failing silently while opponents are discarding', undefined, undefined, undefined));
        v307.push(getContent(PatchNoteType.Fix, 'Fixed issue where placement highlights stayed visible after being robbed of the required resources mid-placement', undefined, undefined, undefined));
        v307.push(getContent(PatchNoteType.Fix, '[C&K] Fixed hovering over any player info arrow not expanding all stats at once'));
        v307.push(getContent(PatchNoteType.Fix, '[C&K] Fixed Spy action appearing in the game state before the card was played'));
        // Jeff
        // Fix bug with friendly robber and monopoly
        // Oguz
        // Rush games now show a "How to Play" info panel during your first 5 games
        // Increased discard card timers in rush 10s, 15s, 20s by 1.5x
        // [Rush] Fixed trade offers you create not appearing until the next dice roll, and your own offers being hidden when you request a resource you don't have
        // [Colonist Rush] Now listed above Cities & Knights in the Ranked tab
        // [Colonist Rush] Logged-out players see login popup instead of seeing the intro popup first
        // Fixed the in-game UI being misaligned with the board until the window was resized
        // Fixed in-game side banners appearing pushed below the screen
        // [Colonist Rush] Friendly Robber is now on by default in Colonist Rush
        // [Colonist Rush] Rush promo ads now open the Rush rulebook instead of queueing/leaderboards/store
        // [Colonist Rush] Patch-notes banner and homepage Rush ads now open the Bots Colonist Rush card instead of the blog/rulebook; the "free Rush in rooms" ad now creates a room
        // Muhammad
        // update rush rules dialog styles
        // React refactor - implement changeusername dialog
        // support setting a portrait mode video in rush rules dialog
        // show rush rules dialog on first queue start
        // add new badge to shuffle bot and ranked cards
        // update change username dialog styles
        // add storybook dialog wrapper
        // React Refactor - build shareimage dialog
        // React Refactor - build shareimage dialog container
        // React Refactor - build edit profile dialog
        // React Refactor - move shareimage dialog
        // Sinan
        // Fix firefox overflow issue in ranked table
        // Fixed Log in link not working on Leaderboards for logged-out users
        // Fix user's own row missing from Leaderboards on Firefox
        // Marc
        // Taking care of feedbacks on the UIGameMapController refactor
        // Dang
        // React Refactor - move analytics calls out of ui-game
        // Remove all mobile landscape relevant code. All mobile web+app users are now portrait only.
        // Migrate old Sound.ts to @colonist/audio
        // Remove Gear icon from Ranked Table
        // React Refactor - Remove UIImagePathController and getLobbyImagePath usage from ui-game package
        // React Refactor - Rewrite UIGame renderer function
        // React Refactor - Remove old hack in game end screen
        // React Refactor - Remove UIGameManager and their relevant usage from `ui-game` package
        // Mo
        // React Refactor - wire up HistoryTable component
        // Goku
        // Rush initial settlement placement are FASTER!
        this.patchNotes.push(getPatchNote(2026, 6, 2, 307, v307));
        const v306 = [];
        v306.push(getContent(PatchNoteType.Fix, '[Colonist Rush] Fixed build buttons disappear when dice are rolled', undefined, undefined, undefined));
        v306.push(getContent(PatchNoteType.Fix, '[Web] Fixed default map zooming to see map fully on first load', undefined, '/v306/map-zoom-before.png', '/v306/map-zoom-after.png'));
        v306.push(getContent(PatchNoteType.Fix, 'Fixed wrong user highlighted on Leaderboards / Friends tab', undefined, undefined, undefined));
        v306.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed overflowing bot selector', undefined, '/v305/fix-overflowing-bot-selector-before.png', '/v305/fix-overflowing-bot-selector-after.png'));
        v306.push(getContent(PatchNoteType.Fix, '[Mobile] Fixed rolled dice not visible during Aqueduct and Gold Tile popups'));
        // Jeff
        // 1. Refactor MechanicRoad to remove deprecated fields
        // 2. Refactor MechanicCity to remove deprecated fields
        // 3. Refactor MechanicCityWall to remove deprecated fields
        // 4. Refactor MechanicIslandExploration to remove deprecated fields
        // 5. Refactor MechanicSpecialBuildPhase to remove deprecated fields
        // Oguz
        // [Rush] Hide incoming trade offers if player don't have the resources to accept
        // Muhammad
        // React Refactor - Move fullscreen membership dialog
        // support all filetypes for a patch note asset
        // Sinan
        // Relaxed eslint rules for cypress tests to allow usage of .then
        // Refactor UIGameMapController
        // Fixed info icon not showing in room mode settings
        // Dang
        // Migrate old Sound.ts to @colonist/audio
        // Remove Gear icon from Ranked Table
        // Remove all mobile landscape relevant code. All mobile web+app users are now portrait only.
        // Migrate old Sound.ts to @colonist/audio
        // Remove Gear icon from Ranked Table
        // Fix incorrect localized store price display
        // [Mobile App] Update Mobile RN App to support 16KB page size
        // Separate native iOS and Android payment feature flags
        // Update mobile app documentation
        // Update mobile app IAP payment documentation
        // Migrate old Sound.ts to @colonist/audio
        // Mo
        // React Refactor - Build and integrate ProfilePageTabsContainer component
        // React Refactor - Rework UIProfileLinkController to use tabId instead of activeLink.hash
        // React Refactor - integrate SearchPlayerInput component into profile page
        // introduce passThroughTranslation util to wrap raw strings in TranslationObject
        // React Refactor - build and integrate OverviewTab component into profile page
        // React Refactor - Build HistoryTab component
        // Irfan
        // Wired up chat and log button click analytics events (UserAccessedChat / UserAccessedLog)
        // Added analytics tracking for guest signup popups (shown, login clicked, continue as guest)
        this.patchNotes.push(getPatchNote(2026, 5, 26, 306, v306));
        const v305 = [];
        v305.push(getContent(PatchNoteType.Fix, 'Fixed room bot card being cutoff in certain languages', undefined, '/v305/room-bot-selector-before.png', '/v305/room-bot-selector-after.png'));
        // Oguz
        // Added Colonist Rush button in bots tab for all users.
        // Added internal video ads for ranked games. All platforms have ads now.
        // Removed login button from landing page; moved language selector to footer.
        // Hide incoming trade requests that the player can't accept in Rush mode
        // Muhammad
        // React Refactor - move patch notes dialog
        // revert cypress snapshot changes
        // Build SegementedControl React component
        // React Refactor - move patch note image dialog to react
        // simplify patch note structure
        // update segmented control styles; pn popup style fixes
        // only apply camelCase to .module.scss
        // React Refactor - Move deviceinfo dialog
        // React Refactor - Build change username dialogs and subdialogs
        // Marc
        // Log in the DB the referral rejection reason
        // Refactor mobile map zooming
        // Mo
        // React Refactor - Build and integrate ProfilePageTabsContainer component
        // React Refactor - Rework UIProfileLinkController to use tabId instead of activeLink.hash
        // React Refactor - integrate SearchPlayerInput component into profile page
        // introduce passThroughTranslation util to wrap raw strings in TranslationObject
        // React Refactor - Build and integrate ItemsTab component
        // Sinan
        // Create Room now defaults to Public on web; mobile flips to Public after the host joins; custom-link and event rooms stay Private
        // Fixed saving room privacy setting starts rooms as public
        // React Refactor - wired RankedTable into leaderboard EJS controllers
        // React Refactor - Disable RankedTable tooltips on touch devices
        // React Refactor - Fixed broken flag images in leaderboard page on Discord
        // Efe
        // Render map tile tooltips above the opponents view and Game info popup instead of behind them
        // Fix low-resolution robber piece on the board
        // Hide rulebook top tabs on scroll down and reveal them on scroll up on mobile
        // Ele
        // Fix web sidebar hover transition speed
        // Ergen
        // Remove Apple smart app banner from landing page
        this.patchNotes.push(getPatchNote(2026, 5, 19, 305, v305));
        const v304 = [];
        v304.push(getContent(PatchNoteType.Update, 'Update homepage bot difficulty selector', undefined, '/v304/homepage-bot-cards-before.png', '/v304/homepage-bot-cards-after.png'));
        v304.push(getContent(PatchNoteType.Update, 'Update room bot difficulty selector', undefined, '/v304/roompage-bot-selector-before.png', '/v304/roompage-bot-selector-after.png'));
        v304.push(getContent(PatchNoteType.Update, '[Mobile] Optimized default map zooming'));
        // Muhammad
        // React Refactor - move refresh app dialog to react
        // React Refactor - improve simple dialog flexibility
        // React Refactor - move become member dialogs to react
        // React Refactor - move profile dialogs to react
        // React Refactor - add TextArea & MaxCharWrapper
        // React Refactor - move browser not compatible to react
        // React Refactor - move more simple dialogs to react
        // React Refactor - move all simple dialogs to react
        // Dang
        // Fix incorrect localized store price display
        // [Mobile App] Update Mobile RN App to support 16KB page size
        // Separate native iOS and Android payment feature flags
        // Update mobile app documentation
        // Mo
        // React Refactor - Build RankedGamesDescriptionDialog component
        // React Refactor - integrate RankedGamesDescriptionDialog component
        // Sinan
        // React Refactor - added clear button variant to PlayerFilterDialogButton
        // React Refactor - integrated PlayerFilter on mobile leaderboard
        this.patchNotes.push(getPatchNote(2026, 5, 12, 304, v304));
        const v303 = [];
        v303.push(getContent(PatchNoteType.Update, '<a href="https://suggestions.colonist.io" target="_blank">New suggestions board!</a> Help us improve Colonist by suggesting new features, reporting bugs, or voting on existing suggestions.', undefined, undefined, '/v302/suggestions-after.png', 'https://suggestions.colonist.io'));
        v303.push(getContent(PatchNoteType.Update, '<a href="/championship2026" target="_blank">Colonist Championship 2026</a> is starting soon!'));
        v303.push(getContent(PatchNoteType.Fix, '[Firefox 149+ / Windows] Fixed WebGL progressive slowdown and crashes'));
        v303.push(getContent(PatchNoteType.Fix, '[Discord Activity] Fixed infinite loading screen on iPad'));
        v303.push(getContent(PatchNoteType.Fix, '[Cities & Knights] Fixed action panels staying open after passing turn'));
        // Jeff
        // Convert MechanicFogTile and MechanicGoldTile to use the new rush data structure
        // Fixing sentry issue: https://katan.sentry.io/issues/7431864375/events/0842d278c9cc4e6d98e499d1b63528e7/?query=is:unresolved%20isFullTradeStateNew%20not%20the%20same%20as%20isFullTradeState
        // Rob
        // Update Todo vs Backlog in linear.md
        // Muhammad
        // React Refactor - change dialogs to close with dialogmanagercontext
        // React Refactor - track open dialogs and close all with popup manager
        // React Refactor - close dialogs with escape key and header X button
        // React Refactor - build/implement RoomItemInfoDialog component
        // React Refactor - build/implement StoreItemInfoDialog component
        // css-lint add check for clientforge files
        // React Refactor - build/implement RulesInfoDialog component
        // React Refactor - build/implement GameSpeedInfoDialog component
        // React Refactor - use react-i18next
        // React Refactor - move simple popups to react
        // Marc
        // Refactor Nolt SSO
        // Update patch note
        // Mo
        // Refactor - Extract dialog icon-buttons in `Dialog.ButtonFooter` into reusable primitives.
        // Migrate change region popup to React
        // React Refactor - add and integrate change region success dialog
        // Efe
        // Fix map tile tooltips clipping behind the bottom action bar and card stack
        // Ergen
        // added new analytic event for rush end turn button
        // Edit /careers page
        // Berkay
        // Fixing flaky test failures - dice randomizer
        // Fixed link previews showing a placeholder icon instead of the Colonist logo when sharing on Discord, Slack, and other platforms
        // Waiting first user interaction for audio context init
        // Fixed link previews showing a placeholder icon instead of the Colonist logo when sharing on Discord, Slack, and other platforms
        // ! PUBLIC PN FORMAT: v298.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], '/v298/before-image.png', '/v298/after-image.png', 'FeatureUpvote link'))
        this.patchNotes.push(getPatchNote(2026, 5, 5, 303, v303));
        const v302 = [];
        v302.push(getContent(PatchNoteType.Update, 'Reduced number of votes required to disable karma by 1'));
        v302.push(getContent(PatchNoteType.Update, '[Rush] Updated end turn button icon to a checkmark', undefined, '/v302/rush-endturnicon-before.png', '/v302/rush-endturnicon-after.png'));
        v302.push(getContent(PatchNoteType.Update, '[Rush] Added arrow icon next to the next Robber player indicator', undefined, '/v302/rushrobber-before.png', '/v302/rushrobber-after.png'));
        v302.push(getContent(PatchNoteType.Update, '[Rush] Updated the Robber tooltip to show the next player to move it', undefined, '/v302/rushtooltip-before.png', '/v302/rushtooltip-after.png'));
        // Jeff
        // Fix replay board state on first open
        // Add season 17
        // Muhammad
        // React Refactor - Build ModeIcon component
        // React Refactor - build new badge component
        // React Refactor - build weekly free badge component
        // React Refactor - build best seller badge component
        // React Refactor - build best value badge component
        // replace react-container-query with useContainerQuery hook
        // React Refactor - Build ModeStats component
        // React Refactor - Build ModeSelectorProgressBar component
        // React Refactor - Build ShuffleIcon component
        // cleanup index.ts export - part 1
        // remove ui-platform/core and move leaderboard to clientforge/pages
        // center leaderboard tab icons when horizontal
        // React Refactor - Cleanup Dialog component - part 1
        // Marc
        // Fix Nolt SSO on mobile
        // Fix Nolt SSO redirect on mobile
        // Fix Nolt SSO auto redirect on mobile app opening in the same webview
        // Hide Suggestions link from more page until feature is fully working
        // Fix tests
        // Sinan
        // React Refactor - add muted variant and small size to Button component
        // React Refactor - create @colonist/consts package for shared constants
        // Reworked general announcement notifications to be lazy and scalable
        // Fix mobile room setup for fresh guest users
        // Remembering last room settings
        // Fix beginner hints showing to non-novices when novice ends turn early
        // Ergen
        // Endgame screen trophyIcon allignment fix
        // PUBLIC PN FORMAT: v298.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], '/v298/before-image.png', '/v298/after-image.png', 'FeatureUpvote link'))
        this.patchNotes.push(getPatchNote(2026, 4, 28, 302, v302));
        const v301 = [];
        v301.push(getContent(PatchNoteType.Update, 'Made player colors consistent across chat and logs', undefined, undefined, undefined));
        v301.push(getContent(PatchNoteType.Fix, 'Fixed player color darkening when voting to end turn in Colonist Rush', undefined, '/v301/rushplayer-before.png', '/v301/rushplayer-after.png'));
        v301.push(getContent(PatchNoteType.Fix, 'Fixed player background changing when voting to end turn in Colonist Rush', undefined, '/v301/rushplayerweb-before.png', '/v301/rushplayerweb-after.png'));
        v301.push(getContent(PatchNoteType.Fix, 'Fixed bug where launching Discord Activity opened a room with id \'overview\'', undefined, undefined, undefined));
        v301.push(getContent(PatchNoteType.Fix, 'Moved coins to the right side of the top navigation bar', undefined, '/v301/coins-navbar-before.png', '/v301/coins-navbar-after.png'));
        // Muhammad
        // cleanup mobile profilepage ejs
        // cc26 update - part 1 setup
        // cc26 update -part 2 replace /refresh-cc25 with /refreshcc26
        // remove sourcemap from production builds (for real this time)
        // hide membership related ads for members
        // build abstract badge component
        // Marc
        // React Refactor - build BottomCtaButtons component
        // React Refactor - integrate BottomCtaButtons component
        // Add Nolt SSO to api routes
        // Dang
        // AI Code review skill
        // Hide all paid features when MobileDisableStore flag enabled
        // Mo
        // React Refactor - add Select component to ui package
        // React Refactor - build change leaderboard region form
        // Sinan
        // fixed missing player filter in the leaderboard page
        // React Refactor - moved PlayerFilter, PlayerFilterDialog, PlayerFilterDialogButton, and SearchPlayerInput to clientforge
        // fixed unusable email pre-fill in Helply support form
        // added info popup when clicking development or progress cards during another player's turn
        // React Refactor - built ResponsivePlayerFilter component
        // fixed & added missing device orientation toggle for tablets back
        // Eleanor
        // updated coin placement on web
        // Ergen
        // add analytics events for in-game settings
        // ! PUBLIC PN FORMAT: v298.push(getContent(PatchNoteType.xxx, 'Description', ['Thanks to'], '/v298/before-image.png', '/v298/after-image.png', 'FeatureUpvote link'))
        this.patchNotes.push(getPatchNote(2026, 4, 21, 301, v301));
        const v300 = [];
        v300.push(getContent(PatchNoteType.Update, 'Improved tile highlights', undefined, '/v299/tile_highlights_before.png', '/v299/tile_highlights_after.png'));
        v300.push(getContent(PatchNoteType.Update, 'Updated sidebar on smaller screens', undefined, '/v300/new-web-sidebar-before.png', '/v300/new-web-sidebar-after.png'));
        v300.push(getContent(PatchNoteType.Update, 'Added Hard Bot difficulty to rooms', undefined, '/v300/hard-bot-before.png', '/v300/hard-bot-after.png', 'https://colonist.featureupvote.com/suggestions/629880/create-option-for-hard-bots-in-create-room-not-just-single-player'));
        v300.push(getContent(PatchNoteType.Update, '[Mobile] Updated in-game floating text confirmation', undefined, '/v299/floating-text-pill-style-before.png', '/v299/floating-text-pill-style-after.png'));
        // Muhammad
        // update mode selector timers to update on better intervals (not every second)
        // fix storybook not loading on local
        // add @vitest/ui to run vitest ui mode
        // fix mountUIReactComponent not enforcing prop types
        // more page - add careers notification
        // remove sourcemap from production builds
        // reduce prop drilling in UIGamePlayerInfo
        // Marc
        // Update monthly revenue report workflow to get gross revenue (gift + credit notes)
        // Update Product Management docs to include project ownership
        // Dang
        // Mobile - Update mobile_rn dependencies and increment build number
        // Show portrait mode opt-in popup for mobile app users who are still playing in Landscape mode
        // React Refactor - Build RankedTable component
        // React Refactor - Handle more edge cases in RankedTable component
        // Mo
        // fix resume button showing for spectators in pause overlay
        // add mechanism to handle membership change cleanup: reset premium preferred color
        // Sinan
        // Fix FAQ page not loading on Discord
        // React Refactor - add muted variant and small size to Button component
        // React Refactor - create @colonist/consts package for shared constants
        // React Refactor - Rework Dialog Content and Footer subcomponents
        // React Refactor - build IconButton component
        // Nesir
        // Replaced old lobby room icons
        // [Colonist Rush] Added ranked helmet icon to distinguish Ranked Rush from Bots Rush
        this.patchNotes.push(getPatchNote(2026, 4, 14, 300, v300));
    }
}
